import apiClient from './apiClient';
import { Role, ApiResponse, ApiError } from '../types/api';

export class RoleService {
  /**
   * Get all roles
   * @returns Promise<Role[]> - Array of roles
   */
  static async getRoles(): Promise<Role[]> {
    try {
      const response = await apiClient.get<ApiResponse<Role[]>>('/roles');
      return response.data.data;
    } catch (error) {
      throw error as ApiError;
    }
  }

  /**
   * Get a specific role by ID
   * @param roleId - The ID of the role to fetch
   * @returns Promise<Role> - Role details
   */
  static async getRole(roleId: number): Promise<Role> {
    try {
      const response = await apiClient.get<ApiResponse<Role>>(`/roles/${roleId}`);
      return response.data.data;
    } catch (error) {
      throw error as ApiError;
    }
  }

  /**
   * Create a new role
   * @param roleData - Role data to create
   * @returns Promise<Role> - Created role
   */
  static async createRole(roleData: Partial<Role>): Promise<Role> {
    try {
      const response = await apiClient.post<ApiResponse<Role>>('/roles', roleData);
      return response.data.data;
    } catch (error) {
      throw error as ApiError;
    }
  }

  /**
   * Update an existing role
   * @param roleId - The ID of the role to update
   * @param roleData - Updated role data
   * @returns Promise<Role> - Updated role
   */
  static async updateRole(roleId: number, roleData: Partial<Role>): Promise<Role> {
    try {
      const response = await apiClient.put<ApiResponse<Role>>(`/roles/${roleId}`, roleData);
      return response.data.data;
    } catch (error) {
      throw error as ApiError;
    }
  }

  /**
   * Delete a role
   * @param roleId - The ID of the role to delete
   * @returns Promise<void>
   */
  static async deleteRole(roleId: number): Promise<void> {
    try {
      await apiClient.delete(`/roles/${roleId}`);
    } catch (error) {
      throw error as ApiError;
    }
  }
}